import { auth } from ".";
import {
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from "firebase/auth";

export const signinWithMail = (
  email: string,
  password: string,
  onSuccess?: () => void,
  onError?: () => void
) => {
  signInWithEmailAndPassword(auth, email, password).catch((err) => {
    console.error(err);
    onError && onError();
  });
};

export const resetPassword = (
  email: string,
  onSuccess?: () => void,
  onError?: () => void
) => {
  sendPasswordResetEmail(auth, email)
    .then(() => {
      console.log("sent password reset mail");
      onSuccess && onSuccess();
    })
    .catch((e) => {
      console.error(e);
      onError && onError();
    });
};

export const logout = () => {
  auth.signOut().catch((err) => console.error("signout failed:", err));
};
